import { Checkbox } from 'antd';
import styled from 'styled-components';

export const CheckboxGroup = styled(Checkbox.Group)`
  display: flex;
  flex-direction: column;
  padding: 8px;

  .ant-checkbox-group-item {
    display: flex;
    margin: 8px;
  }
`;
